import React from "react";

interface ColorVariantCircleProps {
  name: any;
  type: any;
  value: string[];
  selectedColor: any;
  size?: number;
}

export default function ColorVariantCircle({
  name,
  type,
  value,
  selectedColor,
  size = 30,
}: ColorVariantCircleProps) {

  let colors = [];

  // Utility function to check if a string is a valid CSS color
  const isValidCSSColor = (color: any) => {
    const s = new Option().style;
    s.color = color;
    return s.color !== ""; // If it's a valid color, `s.color` will not remain empty
  };

  if (type === "single") {
    colors[0] =
      value?.[0] && value[0] !== ""
        ? value[0]
        : name?.trim() && isValidCSSColor(name)
        ? name
        : "#b67300";
  } else if (type === "dual") {
    if (value?.length === 2 && value[0] !== "" && value[1] !== "") {
      colors = value;
    } else {
      colors[0] =
        value?.[0] && value[0] !== ""
          ? value[0]
          : name?.trim() && isValidCSSColor(name)
          ? name
          : "#b67300";

      colors[1] =
        value?.[1] && value[1] !== ""
          ? value[1]
          : name?.trim() && isValidCSSColor(name)
          ? name
          : "#b67300";
    }
  } else if (type === "mix") {
    colors = value;
  }

  const totalColors = colors?.length;
  const radius = size / 2;

  function customCompare(value1: any, value2: any) {
    // Convert "null" to null and treat it as falsy
    const falsyValues = [false, 0, "", null, undefined, NaN, "null"];

    // Case 1: Both values are considered falsy
    if (falsyValues.includes(value1) && falsyValues.includes(value2)) {
      return true;
    }

    // Case 2: Both values are equal strings
    if (typeof value1 === "string" && typeof value2 === "string") {
      return value1 === value2;
    }

    // Case 3: Any other case returns false
    return false;
  }

  if (colors?.length === 1) {
    return (
      <div
        className={`inline-block  p-[2px] rounded-full border-[3px] ${
          customCompare(name, selectedColor)
            ? "border-primary"
            : "border-secondary"
        } hover:border-primary/50 transition-all duration-300 group`}
      >
        <div
          className="rounded-full"
          style={{ backgroundColor: colors[0], width: size, height: size }}
        />
      </div>
    );
  }

  return (
    <div
      className={`inline-block  p-[2px] rounded-full border-[3px] ${
        customCompare(name, selectedColor)
          ? "border-primary"
          : "border-secondary"
      } hover:border-primary/50 transition-all duration-300 group`}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        {colors?.map((color, index) => {
          const startAngle = (index / totalColors) * 360;
          const endAngle = ((index + 1) / totalColors) * 360;
          const x1 = radius + radius * Math.cos((startAngle * Math.PI) / 180);
          const y1 = radius + radius * Math.sin((startAngle * Math.PI) / 180);
          const x2 = radius + radius * Math.cos((endAngle * Math.PI) / 180);
          const y2 = radius + radius * Math.sin((endAngle * Math.PI) / 180);

          const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

          return (
            <path
              key={color}
              d={`M ${radius},${radius} L ${x1},${y1} A ${radius},${radius} 0 ${largeArcFlag},1 ${x2},${y2} Z`}
              fill={color}
            />
          );
        })}
      </svg>
    </div>
  );
}
